// import Ray from './math/Ray';
import Vector2 from './math/Vector2';
// import Vector4 from './math/Vector4';
import Matrix4x4 from './math/Matrix4x4';
import SortedList from './lists/SortedList';
import Scene from './Scene';
import Light from './rendering/lights/Light';
import DirectionalLight from './rendering/lights/DirectionalLight';
import Renderer from './rendering/Renderer';
import Object3D from './rendering/Object3D';
import Transform from './transformNodes/Transform3D';

import opacities from './rendering/OPACITIES';
import Camera from './rendering/cameras/Camera3D';
import { InteractionType } from './rendering/InteractionHandler';
import Touch from './Touch';

const identityTransform = new Matrix4x4().setToIdentity();

export default class Scene3D extends Scene {
	displayLists: { [opacity: string]: SortedList };
	transform: Transform;
	camera: Camera;
	ambientLight: Light;
	directionalLight: DirectionalLight;

	constructor (camera: Camera) {
		super();

		this.displayLists = {
			// transparent: new SortedList(function (a, b) { return 0; }),
			// TODO: opaque objects could be sorted either by:
			// - the distance to camera (optimizes GPU pixel draw count using default GPU occlusion optimization)
			// - the shader they use (optimizes CPU uniform setting operations)
			opaque: new SortedList(function (a, b) { return 0; }),
			// TODO: transluscent objects should be ordered by distance to camera
			transluscent: new SortedList(function (a, b) { return 0; })
		};

		this.transform = new Transform();

		// TODO: camera should be passed as argument?
		this.camera = camera;
		this.ambientLight = new Light();
		// TODO: direction light should not be able to cast shadows by default
		this.directionalLight = new DirectionalLight();
	}

	render (renderer: Renderer) {
		// Updating lights
		this.ambientLight.updateLight();
		this.directionalLight.updateLight();

		// Updating camera
		let frameBuffer = renderer.getCurrentFrameBuffer();
		this.camera.updateView(frameBuffer.width, frameBuffer.height);

		this.transform.update(identityTransform);

		// Rendering scene as viewed by the camera
		this.camera.render(renderer, this);
	}

	addObject (object: Object3D) {
		switch (object.opacity) {
			case opacities.OPAQUE:
				object.displayListReference = this.displayLists.opaque.add(object);	
				break;
			case opacities.TRANSLUSCENT:
				object.displayListReference = this.displayLists.transluscent.add(object);	
				break;
			default:
				throw new Error('opacity not recognized: ' + object.opacity);
		}

		this.transform.addChild(object.transform);
	}

	removeObject (object: Object3D) {
		switch (object.opacity) {
			case opacities.OPAQUE:
				object.displayListReference = this.displayLists.opaque.removeByReference(object.displayListReference);	
				break;
			case opacities.TRANSLUSCENT:
				object.displayListReference = this.displayLists.transluscent.removeByReference(object.displayListReference);	
				break;
			default:
				throw new Error('opacity not recognized: ' + object.opacity);
		}

		object.transform.removeFromParent();
	}

	onInteraction (interactionType: InteractionType, event, touches: Array<Touch>) {}

	// screenToClipCoordinates (screenCoordinates) {
	// 	// y coordinates is reversed on screen
	// 	var dimensions = renderer.getCanvasDimensions();

	// 	var x = screenCoordinates.x;
	// 	var y = dimensions.y - screenCoordinates.y;

	// 	// Converting to normalized device coordinates
	// 	x = (x - dimensions.x * 0.5) / (dimensions.x * 0.5);
	// 	y = (y - dimensions.y * 0.5) / (dimensions.y * 0.5);

	// 	return new Vector2(x, y);
	// }

	// screenToWorldCoordinates (screenCoordinates, z) {
	// 	z = z || 0;

	// 	// Converting to clip coordinates
	// 	var w = this.camera.getHeight(this.camera._far * z + this.camera._near * (1 - z));
	// 	var clipCoordinates = this.screenToClipCoordinates(screenCoordinates);
	// 	var eyeCoordinates = new Vector4(clipCoordinates.x * w, clipCoordinates.y * w, (z - 0.5) / 0.5 * w, w);

	// 	// Converting to world coordinates
	// 	var vpMatrix = this.camera.getViewProjectionMatrix().withAspectRatio(renderer.getAspectRatio());
	// 	var vpInverse = vpMatrix.inverse();
	// 	return vpInverse.multiplyVector4(eyeCoordinates).toVector3();
	// }

	// createRayFromScreenCoordinates (screenCoordinates) {
	// 	var clipCoordinatesNear = this.screenToClipCoordinates(screenCoordinates);
	// 	var clipCoordinatesFar  = this.screenToClipCoordinates(screenCoordinates);

	// 	var wNear = this.camera.getHeight(this.camera._near);
	// 	var wFar  = this.camera.getHeight(this.camera._far);

	// 	var eyeCoordinatesNear = new Vector4(clipCoordinatesNear.x * wNear, clipCoordinatesNear.y * wNear, -wNear, wNear);
	// 	var eyeCoordinatesFar  = new Vector4(clipCoordinatesFar.x  * wFar,  clipCoordinatesFar.y  * wFar,   wFar,  wFar);

	// 	var vpMatrix = this.camera.getViewProjectionMatrix().withAspectRatio(renderer.getAspectRatio());
	// 	var vpInverse = vpMatrix.inverse();

	// 	var worldCoordinatesNear = vpInverse.multiplyVector4(eyeCoordinatesNear).toVector3();
	// 	var worldCoordinatesFar  = vpInverse.multiplyVector4(eyeCoordinatesFar).toVector3();

	// 	// Returning a ray starting at the computed world coordinates and going in the direction of the view
	// 	return new Ray(worldCoordinatesNear, worldCoordinatesFar.subtraction(worldCoordinatesNear).normalize());
	// }

	// raycast (ray) {
	// 	var intersectedObjects = [];
	// 	this._displayList.forEach(function (sceneObject) {
	// 		// testing intersection with aabb first
	// 		if (sceneObject.intersectsWithRay(ray)) {
	// 			// Computing object intersection with the ray
	// 			var objectIntersection = sceneObject.getAABBRayIntersection(ray);
	// 			if (objectIntersection !== null) {
	// 				intersectedObjects.push(objectIntersection);
	// 			}
	// 		}
	// 	});

	// 	return intersectedObjects;
	// }

	// getObjectsAtScreenCoordinates (screenCoordinates) {
	// 	var ray = this.createRayFromScreenCoordinates(screenCoordinates, 0);
	// 	var intersectedObjects = this.raycast(ray);

	// 	// For debug purpose:
	// 	// TODO: make a proper debug API for raycasting
	// 	// var edgeEnd = ray.source.addition(ray.direction.multiplicationScalar(1000));
	// 	// var rayObject = new WireframeObject(new WireframeMesh({ positions: [ray.source.copy() , edgeEnd], edges: [new Edge(0, 1)] }));
	// 	// this._addObject(rayObject);

	// 	return intersectedObjects;
	// }

	// getClosestObjectAtScreenCoordinates (screenCoordinates) {
	// 	var objectIntersections = this.getObjectsAtScreenCoordinates(screenCoordinates);
	// 	var closestObjectIntersection = null;
	// 	for (var o = 0; o < objectIntersections.length; o += 1) {
	// 		var objectIntersection = objectIntersections[o];
	// 		if (objectIntersection.distance < closestObjectIntersection.distance) {
	// 			closestObjectIntersection = objectIntersection;
	// 		}
	// 	}

	// 	return closestObjectIntersection;
	// }
}
